import introSec from "../../../../assets/Cryptography.jpeg";
import classrom from "../../../../assets/classrom.jpeg";
import global from "../../../../assets/global.jpeg";
import cyberDiff from "../../../../assets/crypto-diff.jpeg";
import CybersecurityProgram from "../../Shared/CybersecurityPrograms";

const CryptographyBasics = () => {
  return (
    <CybersecurityProgram
      backLink="/course/cyber-security"
      heroTitle="Cryptography Basics"
      heroSubtitle="Protecting data through the art and science of encryption."
      heroImage={introSec}
      introParagraphs={[
        "Cryptography is the foundation of modern cybersecurity, ensuring the confidentiality, integrity, and authenticity of data. From simple substitution ciphers to advanced encryption algorithms, cryptography plays a vital role in securing communications and protecting sensitive information.",
        "At JR Institute of Information Technology, students are introduced to the mathematical principles and practical techniques behind cryptography. You'll gain the knowledge and hands-on experience to understand, apply, and evaluate cryptographic methods used in real-world security systems.",
      ]}
      classroom={{
        image: classrom,
        title: "IN THE CLASSROOM",
        paragraphs: [
          "In the classroom, students explore the history of cryptography, symmetric and asymmetric encryption, hashing functions, and digital signatures. Topics include AES, RSA, Diffie-Hellman key exchange, and modern cryptographic standards.",
          "Hands-on labs include encrypting and decrypting messages, generating keys, creating hash digests, and implementing simple secure communication protocols. These activities build the foundation for understanding advanced cybersecurity applications.",
        ],
      }}
      beyondClassroom={{
        image: global,
        title: "BEYOND THE CLASSROOM",
        paragraphs: [
          "Beyond the classroom, learners apply cryptographic concepts in real-world scenarios, from securing online banking transactions to safeguarding cloud storage systems.",
          "Graduates with strong cryptography skills are well-prepared for roles in cybersecurity engineering, penetration testing, blockchain development, and secure software design.",
        ],
      }}
      difference={{
        image: cyberDiff,
        title: "CRYPTOGRAPHY + THE JRIIT DIFFERENCE",
        paragraphs: [
          "What sets JRIIT apart is our approach to making cryptography accessible and practical. Students not only learn the theoretical underpinnings but also practice implementing cryptographic techniques in security labs.",
          "With our applied learning environment, graduates emerge with confidence to design and evaluate secure systems where cryptography is a core requirement.",
        ],
      }}
    />
  );
};

export default CryptographyBasics;
